module.exports = __webpack_public_path__ + "static/img/error-null.770c6a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/error-null.png
// module id = BjS5
// module chunks = 1